<template>
  <span class="wrapper">
    <span class="web__msg--audio talkMsg" v-if="msgObj.msgType === 'text' || msgObj.type === 'text'" v-html="parseText()" />
    <img
      class="web__msg--img"
      v-if="msgObj.msgType === 'img'"
      :src="msgObj.message.url"
      alt
      :onerror="defaultImg"
      @click="showDialog({tag:'img'})"
    />
    <!-- <el-image 
      v-if="msgObj.msgType === 'img'"
      :src="msgObj.message.url" 
      style="max-width: 200px; max-height: 100px"
      :fit="'cover'"
      :preview-src-list="yulanImgList" /> -->

    <!-- <video
      class="web__msg--video"
      v-if="msgObj.msgType === 'video'"
      :src="msgObj.message"
      controls="controls"
      @click="showDialog({tag:'video'})"
    />
    <audio
      class="web__msg--audio"
      v-if="msgObj.msgType === 'audio'"
      style="width:20rem;height:20px;"
      :src="getData.src"
      controls="controls"
    /> -->

    <el-dialog
      :visible.sync="show"
      width="40%"
      append-to-body
      :before-close="handleClose"
      class="web__dialog"
    >
      <img :src="imgSrc" v-if="imgSrc" style="width:100%; object-fit: cover;" />
      <video
        :src="videoSrc"
        v-if="videoSrc"
        style="width:100%;object-fit: cover;"
        controls="controls"
      ></video>
      <audio
        :src="audioSrc"
        v-if="audioSrc"
        style="width:100%;object-fit: cover;"
        controls="controls"
      ></audio>
    </el-dialog>



  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import emojiParser from 'wechat-emoji-parser';
export default {
  props: {
    msgObj: Object,
  },
  data () {
    return {
      tags: ['img', 'video', 'audio'],
      /* 查看文件详情 */
      show: false,
      imgSrc: '',
      videoSrc: '',
      audioSrc: '',
      defaultImg: 'this.src="' + require('@/assets/logo.png')+ '"', // 头像加载失败时默认图片
    }
  },
  computed: {
    ...mapGetters([
      'yulanImgList'
    ]),
    // getTag () {
    //   const str = this.text || ""
    //   let tag = 'span'
    //   let type = ''
    //   const isTag = str.match(/(?!^<)[A-Z|a-z]+/)
    //   isTag && (type = isTag[0])
    //   if (this.tags.includes(type)) {
    //     tag = type
    //   }
    //   return tag
    // },
    getData () {
      const str = this.text || ""
      const dom = document.createElement('div')
      dom.innerHTML = str
      const target = dom.firstChild
      const src = target.getAttribute('data-src')
      const controls = target.getAttribute('controls') || false
      return {
        src,
        controls
      }
    },
  },
  methods: {
    handleClose (done) {
      this.imgSrc = undefined;
      this.videoSrc = undefined;
      this.audioSrc = undefined;
      done();
    },
    showDialog ({ tag }) {
      // const { message } = this.getData(this.msgObj)
      const { message } = this.msgObj
      const callback = () => {
        if (tag === 'img') {
          this.imgSrc = message.url;
          this.show = true;
        } else if (tag === 'video') {
          this.videoSrc = message;
          this.show = true;
        } else if (tag === 'audio') {
          this.audioSrc = message;
          this.show = true;
        } else if (tag === 'FILE') {
          window.open(message)
        }
        
      }
      if (typeof this.beforeOpen === 'function') {
        this.beforeOpen({ tag, message }, callback)
      } else {
        callback();
      }
    },
    parseText () {
      const { msgObj } = this
      if (!msgObj.message) return
      const html = emojiParser(msgObj.message).replace(/<img src/g, '<img style="width:22px;height:22px;vertical-align: bottom;" src').replace(/\n/g,'<br/>')
      return html
    }
  }
}
</script>
<style lange="less" scoped>
.wrapper {
  padding: 0px;
  margin: 0px;
}

.web__msg--img {
  padding: 0;
}

/deep/ .el-dialog__headerbtn {
  top: 10px !important;
}
</style>